import { push } from 'react-router-redux';
import { delay } from 'redux-saga';
import { ROUTES, routeToPath } from '../../commons/routes/routes';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import servicoService from '../../commons/services/servicos';
import { actions, types } from '../modules/servicos';
import { flow } from '../modules/flow';

export default function* servicosSaga() {
	yield takeEvery(types.SERVICOS_CONSULTAR_POR_ID, consultarPorCodigo);
	yield takeEvery(types.SERVICOS_CONSULTAR_POR_FILTRO, consultarPorFiltro);
	yield takeEvery(types.SERVICOS_LIMPAR, limpar);
	yield takeEvery(types.SERVICOS_REMOVER, remover);
	yield takeEvery(types.SERVICOS_SALVAR, salvar);
}

function* consultarPorCodigo(action) {
	yield* flow({
		type: action.type,

		fnTry: function*() {
			const servico = yield call(
				servicoService.consultarPorCodigo,
				action.payload
			);

			yield put(actions.atualizarStore({ servico }));
		}
	});
}

function* consultarPorFiltro(action) {
	yield* flow({
		type: action.type,

		fnTry: function*() {
			const [lista] = yield all([
				call(servicoService.consultarPorFiltro, action.payload || {}),
				call(delay, 750) // adicionado um delay de 750ms para exibir feedback para o usuário
			]);

			yield put(actions.atualizarStore({ lista }));
		}
	});
}

function* limpar(action) {
	yield* flow({
		type: action.type,

		fnTry: function*() {
			yield put(actions.atualizarStore({ servico: null, lista: [] }));
		}
	});
}

function* salvar(action) {
	yield* flow({
		type: action.type,

		fnTry: function*() {
			const [servico] = yield all([
				call(servicoService.salvar, action.payload),
				call(delay, 750) // adicionado um delay de 750ms para exibir feedback para o usuário
			]);

			yield put(
				push(routeToPath(ROUTES.EDITAR_SERVICO, { codigo: servico.codigo }))
			);

			yield put(actions.atualizarStore({ servico }));
		}
	});
}

function* remover(action) {
	yield* flow({
		type: action.type,

		fnTry: function*() {
			yield call(servicoService.remover, action.payload.codigo);

			const [lista] = yield all([
				call(servicoService.consultarPorFiltro, action.payload.search),
				call(delay, 750) // adicionado um delay de 750ms para exibir feedback para o usuário
			]);

			yield put(actions.atualizarStore({ lista }));
		}
	});
}
